// src/index.js
import React from 'react';
import 'styles/global.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'context/AuthContext';
import { TaskProvider } from 'context/TaskContext';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <BrowserRouter>
     <AuthProvider>
       <TaskProvider>
         <App />
       </TaskProvider>
     </AuthProvider>
   </BrowserRouter>
  </React.StrictMode>
);
